/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAuthorizedAccounts} from '../api'

 export const useQueryGetAuthorizedAccounts = createReactQueryHook('getAuthorizedAccounts', getAuthorizedAccounts)
